import React from "react";
import { motion } from "framer-motion";
import { Wordmark } from "./Wordmark";
import { useModal } from "../../lib/ModalContext";
import { EASE, fadeUp } from "../../lib/motion";

export const Footer = ({ content }) => {
    const f = content?.footer || {};
    const { open } = useModal();

    return (
        <footer id="contact" className="relative pt-12 md:pt-16 pb-8 bg-[#ECEBE7]" data-testid="site-footer">
            <div className="editorial-rule mx-6 md:mx-10 mb-10" />
            <div className="mx-auto max-w-[1240px] px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <motion.div {...fadeUp(0)} className="md:col-span-5">
                        <Wordmark
                            logoUrl={content?.brand?.logo_url}
                            brandName={content?.brand?.name}
                            wordmark={content?.brand?.wordmark}
                            logoSize={content?.brand?.logo_size}
                            nameColor={content?.brand?.name_color}
                            nameFont={content?.brand?.name_font}
                            nameSize={content?.brand?.name_size}
                        />
                        <p className="mt-6 font-body text-base text-oth-ink2 leading-relaxed max-w-[380px]">{f.tagline}</p>
                    </motion.div>

                    {(f.columns || []).map((col, i) => (
                        <motion.div key={`col-${col.title || i}`} {...fadeUp(0.1 + i * 0.08)} className="md:col-span-2">
                            <div className="text-xs uppercase tracking-[0.22em] text-oth-ink3 font-body">{col.title}</div>
                            <ul className="mt-5 space-y-3">
                                {(col.links || []).map((l) => {
                                    const testId = `footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`;
                                    const href = (l.href || "").toLowerCase();
                                    // Convert special hash links into modal triggers.
                                    if (href === "#disclaimer") {
                                        return (
                                            <li key={l.label}>
                                                <button onClick={() => open("disclaimer")} className="nav-link text-sm" data-testid={testId}>
                                                    {l.label}
                                                </button>
                                            </li>
                                        );
                                    }
                                    if (href === "#contact") {
                                        return (
                                            <li key={l.label}>
                                                <button onClick={() => open("contact")} className="nav-link text-sm" data-testid={testId}>
                                                    {l.label}
                                                </button>
                                            </li>
                                        );
                                    }
                                    return (
                                        <li key={l.label}>
                                            <a href={l.href} className="nav-link text-sm" data-testid={testId}>
                                                {l.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </motion.div>
                    ))}

                    <motion.div {...fadeUp(0.3)} className="md:col-span-3">
                        <div className="text-xs uppercase tracking-[0.22em] text-oth-ink3 font-body">Connect</div>
                        <ul className="mt-5 space-y-3">
                            {(f.socials || []).map((s) => (
                                <li key={s.label}>
                                    <a href={s.href} target="_blank" rel="noreferrer" className="nav-link text-sm opacity-80 hover:opacity-100" data-testid={`footer-social-${s.label.toLowerCase()}`}>{s.label}</a>
                                </li>
                            ))}
                        </ul>
                    </motion.div>
                </div>

                <motion.div {...fadeUp(0.4)} className="mt-12 pt-6 border-t border-oth-line/70 flex flex-col md:flex-row md:justify-between gap-3 text-xs text-oth-ink3 font-body">
                    <span>{f.rights}</span>
                    <span>Crafted with quiet intent.</span>
                </motion.div>
            </div>
        </footer>
    );
};
